<template>
  <div>
    <b-form-select v-model="selected" :options="options" @change="$emit('input', selected)"></b-form-select>
  </div>
</template>

<script>
import i18n from '../../i18n';
export default {
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: i18n.t('Nenhuma') },
        { value: 1, text: i18n.t('Depósito') },
        { value: 2, text: i18n.t('Documento') }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
